module.exports = __webpack_public_path__ + "img/umb39_uv_sleeve.1668ee7e.svg";